import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import EcommerceHub from "@/pages/EcommerceHub";
import CropToolPage from "@/pages/CropToolPage";
import MergePdf from "@/pages/MergePdf";
import RearrangePdf from "@/pages/RearrangePdf";
import ImageResizer from "@/pages/ImageResizer";
import AiTools from "@/pages/AiTools";
import AiToolPage from "@/pages/AiToolPage";
import PdfCropperHub from "@/pages/PdfCropperHub";
import ProfitCalculator from "@/pages/ProfitCalculator";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/ecommerce-tools" element={<EcommerceHub />} />
            <Route path="/tools/merge-pdf" element={<MergePdf />} />
            <Route path="/tools/rearrange-pdf" element={<RearrangePdf />} />
            <Route path="/tools/product-image-resizer" element={<ImageResizer />} />
            <Route path="/tools/amazon-product-image-resizer" element={<ImageResizer variant="amazon" />} />
            <Route path="/tools/meesho-product-image-resizer" element={<ImageResizer variant="meesho" />} />
            <Route path="/tools/pdf-shipping-label-cropper" element={<PdfCropperHub />} />
            <Route path="/profit-calculator" element={<ProfitCalculator />} />
            <Route path="/tools/:slug" element={<CropToolPage />} />
            <Route path="/ai-tools" element={<AiTools />} />
            <Route path="/ai-tools/:slug" element={<AiToolPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
